<template>
    <div class="row">
        <div class="col-12">
            <div class="card mb-4">
                <div class="card-header pb-0">
                    <div class="row">
                        <div class="col-12 d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">Top Up History</h6>
                            <button class="btn bg-gradient-dark mb-0 ms-auto"
                                    :disable="exportLoading"
                                    @click="exportTopUps">
                                <i class="fas fa-download" v-if="!exportLoading"></i>

                                <div class="spinner-border spinner-border-sm"
                                     role="status"
                                     v-if="exportLoading">
                                    <span class="sr-only">Loading...</span>
                                </div>
                                Export
                            </button>
                        </div>
                    </div>
                </div>
                <hr class="mx-3" style="border-top: 1px solid !important" />
                <topup-header />
                <topup-list />
            </div>
        </div>
    </div>
</template>

<script>
    import topupHeader from "./components/header.vue";
    import topupList from "./components/topupList.vue";
    import { mapActions, mapState } from "vuex";

    export default {
        components: {
            "topup-header": topupHeader,
            "topup-list": topupList,
        },
        computed: {
            ...mapState({
                filter: (state) => state.retailerController.transactionsFilter,
                loading: (state) => state.retailerController.transactionsLoading,
                exportLoading: (state) =>
                    state.retailerController.topUpsExportLoading,
            }),
        },
        methods: {
            ...mapActions({
                getTransactions: "retailerController/GetTransactions",
                exportTopUps: "retailerController/ExportTopUpHistory",
            }),
        },
    };
</script>

<style>
</style>